import React, { useEffect, useState } from 'react';
import { IComponentFormOcr } from '../../component';
import SearchRow from './SearchRow';
import ComponentLink from '../ComponentLink';
import SearchResult from './SearchResult';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';

interface IAllForOcr extends IComponentFormOcr {
  rootStore?: RootStore;
}
const AllForOcr = function(props: IAllForOcr) {
  const { rootStore, placeholder } = props;
  const { wxuserStore } = rootStore!;
  const [showResult, setShowResult] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [list, setList] = useState([]);
  const searchNumber = (number: string) => {
    setShowResult(true);
    if(keyword != number) {
      setList([]);
    }
    setKeyword(number);
  };
  const formatList = (list: any[]) => {
    if (!list) {
      return [];
    }
    //处理成需要的数据，注意，这会覆盖掉一部分数据，考虑到覆盖的数据暂时无用，也就无所谓了，实在需要再考虑在这里单独处理
    const newList = list.map((one: any) => {
      if(one && Number(one.trash) > 0) {
        return null;
      }
      return one;
    }).filter(Boolean);
    return newList;
  };
  useEffect(() => {
    if (keyword) {
      wxuserStore
        .ocr(
          keyword,
          window.dataDetail ? window.dataDetail.id : window.gallery.id
        )
        .then((jsonData: any) => {
          setList(formatList(jsonData) as never[]);
        });
    }
  }, [keyword]);

  return (
    <div className="all-for-ocr">
      <SearchRow search={searchNumber} placeholder={placeholder} />
      {showResult && (
        <SearchResult
          keyword={keyword}
          list={list}
          close={() => setShowResult(false)}
        />
      )}
    </div>
  );
};

export default inject('rootStore')(observer(AllForOcr));
